module.exports = __webpack_public_path__ + "img/gentlemen-club-story-3.e24a25fe.png";